import RequestType from '@Enum/RequestTypes.enum';
import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useRequestDictionaryLoader = (): RequestType | undefined => {
  const { pathname } = useLocation();
  const [requestName, setRequestName] = useState<RequestType>();

  useLayoutEffect(() => {
    if (pathname.includes('material-request') || pathname.includes('MR')) {
      setRequestName(RequestType.MATERIAL);
    }

    if (pathname.includes('purchase-request')) {
      setRequestName(RequestType.PURCHASE);
    }

    if (pathname.includes('tender-request')) {
      setRequestName(RequestType.TENDER);
    }
  }, [pathname]);

  return requestName;
};

export default useRequestDictionaryLoader;
